import React from "react";
import LayoutStoreHome from "../../layouts/LayoutStoreHome";
import Hero from "../../components/sections/Hero";
import Features from "../../components/sections/Features";
import Latest from "../../components/sections/Latest";
import About from "../../components/sections/About";

const StoreHome = () => {
  return (
    <LayoutStoreHome>
      {/**Hero */}
      <Hero />
      {/**Features section */}
      <Features />
      {/**Latest section */}
      <Latest />
      {/**About section */}
      <About />
    </LayoutStoreHome>
  );
};

export default StoreHome;
